// extracted by mini-css-extract-plugin
export var brand = "_al-9";
export var compact = "_al-6";
export var extraSmall = "_al-7";
export var icon = "_al-0";
export var large = "_al-4";
export var light = "_al-1";
export var medium = "_al-5";
export var outline = "_al-b";
export var primaryDark = "_al-a";
export var primaryLight = "_al-8";
export var primaryModern = "_al-c";
export var success = "_al-2";
export var successSolid = "_al-3";